/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Legal_Travel_AriaInputs */

const en_service_legal_travel_aria = /** @type {(inputs: Service_Legal_Travel_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link to Travel Legal Service`)
};

const fr_service_legal_travel_aria = /** @type {(inputs: Service_Legal_Travel_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lien vers le service d'assistance juridique en voyage`)
};

/**
* | output |
* | --- |
* | "Link to Travel Legal Service" |
*
* @param {Service_Legal_Travel_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const service_legal_travel_aria = /** @type {((inputs?: Service_Legal_Travel_AriaInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Legal_Travel_AriaInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_service_legal_travel_aria(inputs)
	return fr_service_legal_travel_aria(inputs)
});